import ProductPageDesktop from './ProductPageDesktop/ProductPageDesktop'
import ProductPageMobile from './ProductPageMobile/ProductPageMobile'
import useBreakpoint from '@/hooks/use-breakpoint'

export const ProductPage = productPage => {
  const { isMobile } = useBreakpoint()

  if (isMobile === null) return null

  return isMobile ? (
    <ProductPageMobile
      key={productPage?.slug?.current}
      {...productPage}
    />
  ) : (
    <ProductPageDesktop
      key={productPage?.slug?.current}
      {...productPage}
    />
  )
}

export default ProductPage
